import AnswerSourcesPanel from '@app/src/pages/Questionnaire/Accessor/Report/AiScreening/AnswerSourcesPanel'
import OldScrapedAnswerCitations from '@app/src/pages/Questionnaire/Accessor/Report/AiScreening/OldScrapedAnswerCitations'
import type { Provider } from '@app/src/types/organizations'
import type { ScrapedAnswer } from '@app/src/types/resourceExplorer'
import React from 'react'

interface ScrapedAnswerSectionProps {
  scrapedAnswer: ScrapedAnswer | undefined
  questionType: string
  provider?: Provider
}

export const CitationsForScrapedAnswer: React.FC<ScrapedAnswerSectionProps> = ({
  scrapedAnswer,
  questionType,
  provider,
}: ScrapedAnswerSectionProps) => {
  if (scrapedAnswer?.citations?.length)
    return <OldScrapedAnswerCitations citations={scrapedAnswer.citations} provider={provider} />

  if (scrapedAnswer?.searchResults || scrapedAnswer?.answerBackgroundSummary)
    return <AnswerSourcesPanel scrapedAnswer={scrapedAnswer} />

  return null
}
